import { Portals, useLlm } from '@websolutespa/bom-mixer-llm';

export const InPagePrompt: React.FC = () => {
  const {
    Prompt,
  } = useLlm(state => state.components);
  return (
    <Portals>
      <Prompt {...({ suggestions: true } as any)} />
    </Portals>
  );
};

